export default __webpack_public_path__ + "static/media/a-icon-phone.ed868002.svg";